// Lib
import { useEffect } from 'react';
import { toCssPx } from '../../../../utils/cssUtil';
import {
    getDefaultTableCellLineHeight,
    getDefaultTableCellVerticalPadding,
} from '../utils/hotInstanceUtils/hotTableGridDefaultDimensionUtils';
import { MNHotInstance } from '../../tableHotInstanceTypes';

interface UseTableColumnResizeEffectsProps {
    gridSize: number;
    hotTableInstanceRef: React.MutableRefObject<MNHotInstance | null>;
}

/**
 * Custom hook for managing table effects from Milanote grid size changes
 */
export const useTableGridSizeEffects = (props: UseTableColumnResizeEffectsProps): void => {
    const { gridSize, hotTableInstanceRef } = props;

    /**
     * Update HOT CSS variables to determine row height
     *
     * This needs to be done using JS because HOT requires these values to be in PX
     * in order for the height to be calculated properly
     */
    useEffect(() => {
        const hotInstance = hotTableInstanceRef.current;
        if (!hotInstance) return;

        hotInstance.rootElement.style.setProperty('--ht-line-height', toCssPx(getDefaultTableCellLineHeight(gridSize)));
        hotInstance.rootElement.style.setProperty(
            '--ht-cell-vertical-padding',
            toCssPx(getDefaultTableCellVerticalPadding(gridSize)),
        );

        // Force Handsontable to recalculate cell height from the newly updated CSS variables above
        hotInstance.stylesHandler.clearCache();
    }, [gridSize]);
};

export default useTableGridSizeEffects;
